/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { D as DHL_INDICATOR_STEP } from './constants-35b5fb29.js';

const DHL_PROGRESS_INDICATOR = {
    SIZE: DHL_INDICATOR_STEP.SIZE,
    TYPE: DHL_INDICATOR_STEP.TYPE,
    STEP: DHL_INDICATOR_STEP.STEP,
    CONNECTOR_TYPE: DHL_INDICATOR_STEP.CONNECTOR_TYPE,
};

export { DHL_PROGRESS_INDICATOR as D };

//# sourceMappingURL=constants-1537c594.js.map